import React from 'react'

export const IcoCalendar = ({...props}) => {
  const style = props.style?props.style:{}
  return (
    <svg className='icon-calendar' viewBox="0 0 14 14" {...props} style={{...style,fill:'none'}}>
      <path d="M3.5 1V2.5M10.5 1V2.5M1 11.5V4C1 3.60218 1.15804 3.22064 1.43934 2.93934C1.72064 2.65804 2.10218 2.5 2.5 2.5H11.5C11.8978 2.5 12.2794 2.65804 12.5607 2.93934C12.842 3.22064 13 3.60218 13 4V11.5M1 11.5C1 11.8978 1.15804 12.2794 1.43934 12.5607C1.72064 12.842 2.10218 13 2.5 13H11.5C11.8978 13 12.2794 12.842 12.5607 12.5607C12.842 12.2794 13 11.8978 13 11.5M1 11.5V6.5C1 6.10218 1.15804 5.72064 1.43934 5.43934C1.72064 5.15804 2.10218 5 2.5 5H11.5C11.8978 5 12.2794 5.15804 12.5607 5.43934C12.842 5.72064 13 6.10218 13 6.5V11.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}